import { Heading, SimpleGrid } from '@chakra-ui/react'
import { NextPage } from 'next'
import React from 'react'
import {
    generateCuratedBoardLink,
    parseBDBEnvSubdomain,
} from 'src/features/favorites/utils/helpers'
import BoardPreviewCard from 'src/features/saved/components/BoardPreviewCard/BoardPreviewCard'
import SkeletonBoardPreviewCard from 'src/features/saved/components/BoardPreviewCard/SkeletonBoardPreviewCard'
import useCuratedBoards from 'src/hooks/useCuratedBoards'

type PageProps = {
    hostname: string
}

const Page: NextPage<PageProps> = ({ hostname }) => {
    const envSubdomain = parseBDBEnvSubdomain(hostname)
    const { curatedBoards, loading } = useCuratedBoards(envSubdomain)

    return (
        <div className='mb-12 flex h-full w-full flex-col'>
            <div className='mb-6 w-full border-b-px border-gray-100 bg-white p-4 md:mb-16 md:p-8'>
                <Heading as='h1' size={{ base: 'h6', md: 'h4' }} className='mb-0'>
                    Curated Boards
                </Heading>
            </div>
            <div className='mx-auto flex w-full max-w-screen-xl justify-center px-4 md:px-8'>
                <SimpleGrid spacing={14} columns={{ sm: 1, md: 2, lg: 3 }} w='full'>
                    {!loading ? (
                        <>
                            {curatedBoards.map(
                                (board) =>
                                    board && (
                                        <BoardPreviewCard
                                            key={board.id}
                                            board={board}
                                            boardTitle={board.title}
                                            routesLength={board.routes.length}
                                            favorites={board.favorites}
                                            boardLink={generateCuratedBoardLink(
                                                board.id,
                                                envSubdomain
                                            )}
                                            route={board.routes[0]}
                                        />
                                    )
                            )}
                        </>
                    ) : (
                        <>
                            <SkeletonBoardPreviewCard />
                            <SkeletonBoardPreviewCard />
                            <SkeletonBoardPreviewCard />
                        </>
                    )}
                </SimpleGrid>
            </div>
        </div>
    )
}

Page.getInitialProps = async ({ req }) => {
    return {
        hostname: req ? req.headers.host : window.location.hostname,
    }
}

export default Page
